import React, { useEffect, useState } from 'react'
import PopUp from '../../../../ui/PopUp/PopUp'
import Spinner from '../../../../ui/Spinner/Spinner'
import getSmsMessage from '../../../../api/sms/getSmsMessage'
import { formatSmsAuthorName } from '../../../../config/smsAccessControl'
import {
  SMS_DELIVERY_LABELS,
  SMS_SOURCE_LABELS,
  SMS_SUBMISSION_LABELS,
  formatSmsLabel,
  formatSmsTimestamp,
} from './smsUiUtils'

function DetailLine({ label, value, tone }) {
  const display = value == null || value === '' ? '—' : value
  return (
    <div className={['SmsDetail-Line', tone ? `SmsDetail-Line_tone_${tone}` : ''].filter(Boolean).join(' ')}>
      <span className="SmsDetail-Label">{label}</span>
      <span className="SmsDetail-Value">{display}</span>
    </div>
  )
}

function SmsDetailPopUp({ smsMessageId, onClose }) {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState('')
  const [item, setItem] = useState(null)

  useEffect(() => {
    let cancelled = false
    setIsLoading(true)
    setError('')
    getSmsMessage({ smsMessageId }).then((result) => {
      if (cancelled) return
      if (!result.ok) {
        setError(result.message || 'Не вдалося завантажити SMS')
        setIsLoading(false)
        return
      }
      setItem(result.data?.item || null)
      setIsLoading(false)
    })
    return () => {
      cancelled = true
    }
  }, [smsMessageId])

  const errorText = item ? item.normalizedError || item.errorCode || '' : ''

  return (
    <PopUp show={Boolean(smsMessageId)} title="Деталі SMS" close={onClose}>
      {isLoading ? (
        <Spinner type="popup" />
      ) : error ? (
        <p className="SmsDetail-Error">{error}</p>
      ) : item ? (
        <div className="SmsDetail">
          <div className="SmsDetail-TextBlock">
            <span className="SmsDetail-SectionTitle">Текст SMS</span>
            {item.text ? (
              <pre className="SmsDetail-Text">{item.text}</pre>
            ) : (
              <p className="SmsDetail-TextMuted">Текст не зберігається для цього типу SMS (наприклад OTP).</p>
            )}
          </div>

          <div className="SmsDetail-Section">
            <DetailLine label="Номер" value={item.recipient || item.maskedRecipient} />
            <DetailLine label="Дата" value={formatSmsTimestamp(item.createdAt)} />
            <DetailLine
              label="Статус відправки"
              value={formatSmsLabel(SMS_SUBMISSION_LABELS, item.submissionStatus)}
            />
            <DetailLine
              label="Статус доставки"
              value={formatSmsLabel(SMS_DELIVERY_LABELS, item.deliveryStatus)}
            />
            {errorText ? <DetailLine label="Помилка" value={errorText} tone="error" /> : null}
          </div>

          <div className="SmsDetail-Section">
            <DetailLine label="Причина" value={item.reason} />
            <DetailLine
              label="Автор"
              value={formatSmsAuthorName(item.createdBy, item.createdByLabel)}
            />
            <DetailLine label="Тип повідомлення" value={formatSmsLabel(SMS_SOURCE_LABELS, item.source)} />
            <DetailLine label="Відправник" value={item.sender} />
          </div>

          <div className="SmsDetail-Tech">
            <span className="SmsDetail-SectionTitle">Технічні дані</span>
            <DetailLine label="ID у TurboSMS" value={item.providerMessageId} />
            <DetailLine label="ID послідовності" value={item.sequenceId} />
            <DetailLine label="ID автора" value={item.createdBy} />
          </div>
        </div>
      ) : (
        <p>SMS не знайдено</p>
      )}
    </PopUp>
  )
}

export default SmsDetailPopUp
